import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";

const CampaignFilter = ({
    applyFilter,
    reportees = [],
    cities = [],
    zones = [],
    getZones,
    getAreas,
    isRoleId
    }) => {
    const filterInputs = {
        campaign_type: "",
        campaign_subtype: "",
        start_date: "",
        created_by: "",
        created_email: "",
        status_name: "",
        check_invoice: ""
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    const [listStatus, setListStatus] = useState("");
    const [leadOwner, setLeadOwner] = useState("");
    const [isFocus2, setIsFous2] = useState(false);
    const [minDate, setMinDate] = useState(null);


    useEffect(() => {
        (async () => {
            const roles = await JSON.parse(
                localStorage.getItem("applyFilter") &&
                localStorage.getItem("applyFilter")
            );
            const status = await JSON.parse(
                localStorage.getItem("statusFilter") &&
                localStorage.getItem("statusFilter")
            );
            if (roles && status) {
                setFilterFieldsData(roles);
                setListStatus(status);
            }
        })();
    }, []);

    const handleDateChange2 = (jsdate, dateString) => {
        setFilterFieldsData({
          ...filterFieldsData,
          start_date: dateString,
        });
        setMaxToDate(dateString);
      };

    const setMaxToDate = (val) => {
        if (val != 'Invalid date') {
          var dateParts = val.split("-");
          // month is 0-based, that's why we need dataParts[1] - 1
          var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
          setMinDate(dateObject);
        } else {
            setMinDate(null);
        }
      }

      const handleDateHide2 = () => {
        if (!filterFieldsData.start_date) {
          setIsFous2(true);
        }
      };


    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
                filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
                listStatus && localStorage.setItem("statusFilter", JSON.stringify(listStatus));
            }}
        >
            <DropDownInput
                data={[
                    {id: 'Online', name: 'Online'},
                    {id: 'Offline', name: 'Offline'}
                ]}
                label={localization.campaignType}
                value={filterFieldsData?.campaign_type !== null ? filterFieldsData?.campaign_type : ''}
                getIdValue={(val) => {
                    setFilterFieldsData({
                    ...filterFieldsData,
                    campaign_type: val.id,
                    });
                }}
            />
            <DropDownInput
                data={[
                    { id: "Impression based", name: "Impression based" },
                    { id: "Lead based", name: "Lead based" },
                    { id: "App installs", name: "App installs" },
                    { id: "CTR", name: "CTR" },
                    { id: "Lead conversions", name: "Lead conversions" },
                ]}
                label={localization.campaignSubtype}
                getIdValue={(val) => {
                    setFilterFieldsData({
                    ...filterFieldsData,
                    campaign_subtype: val.id,
                    });
                }}
            />
            <DropDownInput
                data={[
                    {id: 'Manager Pending', name: 'Manager Pending'},
                    {id: 'Manager Rejected', name: 'Manager Rejected'},
                    {id: 'L2 Pending', name: 'L2 Pending'},
                    {id: 'Invoice Pending', name: 'Invoice Pending'},
                    {id: 'Invoice Created', name: 'Invoice Created'}
                ]}
                label={localization.status}
                value={filterFieldsData?.status_name !== null ? filterFieldsData?.status_name : ''}
                getIdValue={(val) => {
                    setFilterFieldsData({
                    ...filterFieldsData,
                    status_name: val.id,
                    });
                }}
            />
            <DropDownInput
                data={[
                    {id: 'Yes', name: 'Yes'},
                    {id: 'No', name: 'No'}
                ]}
                label={'Is Invoice Created'}
                value={filterFieldsData?.check_invoice !== null ? filterFieldsData?.check_invoice : ''}
                getIdValue={(val) => {
                    setFilterFieldsData({
                    ...filterFieldsData,
                    check_invoice: val.id,
                    });
                }}
            />
            <DatePickerInput
                onChange={handleDateChange2}
                value={filterFieldsData.start_date}
                autoClose
                onShow={() => setIsFous2(true)}
                onHide={handleDateHide2}
                closeOnClickOutside
                showOnInputClick
                locale="en"
                className="my-custom-datepicker-component"
                displayFormat="DD-MM-YYYY"
                returnFormat="DD-MM-YYYY"
                placeholder="Start date (DD-MM-YYYY)"
            />

            <br/>
            <br/>

            {/* <ConstantInput
                label={localization.createdBy}
                value={filterFieldsData && filterFieldsData.created_by}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, created_by: val });
                }}
            />
            <ConstantInput
                label={localization.createdEmail}
                value={filterFieldsData && filterFieldsData.created_email}
                type="email"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, created_email: val });
                }}
            /> */}

            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src={Images?.ArrowRight} alt="" />
                </button>
                <br/>
                <br/>
                <button
                    onClick={() => {
                        localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
                        applyFilter(filterInputs);
                        localStorage.setItem("statusFilter", JSON.stringify({}));
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default CampaignFilter;
